import { render, staticRenderFns } from "./NewWorkingDays.vue?vue&type=template&id=13a59ae2&"
import script from "./NewWorkingDays.vue?vue&type=script&lang=js&"
export * from "./NewWorkingDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports